import React from 'react'
import './portfolio.css'
import IMG1 from '../../assets/portfolio1.jpg'
import IMG2 from '../../assets/portfolio2.png'
import IMG3 from '../../assets/portfolio3.jpg'
import IMG4 from '../../assets/portfolio4.jpg'
import IMG5 from '../../assets/portfolio5.png'
import IMG6 from '../../assets/portfolio6.jpg'
import IMG7 from '../../assets/portfolio7.jpg'
import IMG8 from '../../assets/portfolio8.jpg'
import IMG9 from '../../assets/portfolio9.jpg'
import IMG10 from '../../assets/portfolio10.jpg'
import IMG11 from '../../assets/portfolio11.jpg'
import IMG12 from '../../assets/portfolio12.jpg'
import IMG13 from '../../assets/portfolio13.jpg'


   

const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">

      <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG13} alt="" />
          </div><br></br>
          <h4>Online Coffee Ordering Mobile App UI and Case Study</h4>
          <h6> Here is the UI/UX Design for Coffee Ordering mobile app with Case Study. awith user centric
             I design this App by giving user to best ecxpereience.
            </h6><br></br>
          <div className="portfolio__item-cta">
          
          <a href="https://www.behance.net/gallery/182193231/UIUX-Design-for-Online-Coffee-Ordering-Mobile-App/modules/1029279743" className='btn btn-primary' target='_blank'>Open Project</a>
          </div>

        </article>

      <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG12} alt="" />
          </div><br></br>
          <h4>Thilakawardhana Women Wear Page Modification</h4>
          <h6>Explore my transformative UI design for Thilakawardana Clothing Store's women's wear interface—a seamless fusion 
            of aesthetics and functionality. With adept problem-solving, I crafted an engaging online shopping experience. Discover this harmonious 
            blend on my portfolio. Your feedback is invaluable, and I'm open to collaborations that redefine digital creativity. Thank you for being 
            part of this design odyssey. 
            </h6><br></br>
          <div className="portfolio__item-cta">
          
          <a href="https://www.behance.net/gallery/180685071/E-Commerce-Checkout-Process-Modification/modules/1020643141" className='btn btn-primary' target='_blank'>Open Project</a>
          </div>

        </article>

      <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG11} alt="" />
          </div><br></br>
          <h4>E-Commerce Checkout Process Modification</h4>
          <h6>I revamped Amazon's checkout, prioritizing user experience. I streamlined payment info, 
            reduced form fields, and ensured a clear interface. Result: happier users, fewer cart abandonments, and improved conversions. 
            </h6><br></br>
          <div className="portfolio__item-cta">
          
          <a href="https://www.behance.net/gallery/180685071/E-Commerce-Checkout-Process-Modification/modules/1020643141" className='btn btn-primary' target='_blank'>Open Project</a>
          </div>

        </article>
        
        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG1} alt="" />
          </div><br></br>
          <h4>Online Cake Delivery Application User Interface</h4>
          <h6>Created with Figma, it enhances my skills. Enjoy seamless cake ordering with delightful visuals and an 
            intuitive experience. Indulge in the joy of cakes and convenience.</h6><br></br>
          <div className="portfolio__item-cta">
          
          <a href="https://www.behance.net/gallery/175073533/Online-Cake-Delivery-Application/modules/988697517" className='btn btn-primary' target='_blank' rel="noreferrer">Open Project</a>
          </div>

        </article>

        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG2} alt="" />
          </div><br></br>
          <h4>Hotel Booking System in Srilanka</h4>
          <h6>A Hotel Booking System UI Design. Created with Figma, it showcases seamless navigation and elegant visuals. 
            Book your dream accommodations with ease and celebrate the fusion of aesthetics and 
            functionality.</h6><br></br>
          <div className="portfolio__item-cta">
          
          <a href="https://www.behance.net/gallery/176394549/Hotels-Booking-Website/modules/996249111" className='btn btn-primary' target='_blank'>Open Project</a>
          </div>

        </article>
        
        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG3} alt="" />
          </div><br></br>
          <h4>Cat Adopting Home Page</h4>
          <h6>A cat adoption UI design. Created with Figma, it enhances my skills. The interface is simple, user-friendly, 
            with cute cat illustrations. Find your perfect feline companion.</h6><br></br>
          <div className="portfolio__item-cta">
          
          <a href="https://www.behance.net/gallery/175417777/Simple-Cat-Adopt-Page/modules/990688493" className='btn btn-primary' target='_blank'>Open Project</a>
          </div>

        </article>

        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG4} alt="" />
          </div><br></br>
          <h4>Simple School Management System</h4>
          <h6>a Simple School Management System UI Design. With Figma, enjoy a user-friendly login, registration, 
            and dashboard. Seamlessly navigate, simplify school management, and delight users.</h6><br></br>
          <div className="portfolio__item-cta">
         
          <a href="https://www.behance.net/gallery/175416993/Simple-Student-Management-System/modules/990684081" className='btn btn-primary' target='_blank'>Open Project</a>
          </div>
          </article>

        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG5} alt="" />
          </div><br></br>
          <h4>Teleseen Home Page Redesigning</h4>
          <h6>Using Figma, I transformed this e-commerce system with creative ideas. Expect captivating visuals, 
            and an intuitive shopping experience. Embrace the art of creativity, 
            design, and technology in this revitalized Teleseen platform.</h6><br></br>
          <div className="portfolio__item-cta">
          
          <a href="https://www.behance.net/gallery/176729553/Teleseen-Home-Page-Redesigning/modules/998178259" className='btn btn-primary' target='_blank'>Open Project</a>
          </div>

        </article>

        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG6} alt="" />
          </div><br></br>
          <h4>FlowerShop Home Page Design</h4>
          <h6>A flower shop UI design crafted using Figma, showcasing my skill growth. The interface exudes simplicity, user-friendliness,
             adorned with elegant floral motifs. Discover and choose your ideal blossoms effortlessly.</h6><br></br>
          <div className="portfolio__item-cta">
          
          <a href="https://www.behance.net/gallery/177942311/Flower-Shop-Home-Page-Designing/modules/1005044149" className='btn btn-primary' target='_blank'>Open Project</a>
          </div>

        </article>

        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG7} alt="" />
          </div><br></br>
          <h4>Film Download Website User Interface</h4>
          <h6>UI design for a Film Download Website, specifically for Harry Potter movies. 
            Designed using Figma, showcasing my expertise. The interface offers easy navigation, themed around the enchanting world of Harry Potter. 
            Seamlessly download your magical film favorites.</h6><br></br>
          <div className="portfolio__item-cta">
          
          <a href="https://www.behance.net/gallery/178404107/Film-Download-Website-User-Interface/modules/1007639971" className='btn btn-primary' target='_blank'>Open Project</a>
          </div>

        </article>

        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG8} alt="" />
          </div><br></br>
          <h4>Grocery Item View Page</h4>
          <h6>UI design for a Item View User Interface, for keels online. 
            Designed using Figma, showcasing my expertise. The interface offers easy navigation, themed around the enchanting grocery items. 
            </h6><br></br>
          <div className="portfolio__item-cta">
          
          <a href="https://www.behance.net/gallery/178706533/Grocery-Item-View-Page/modules/1009345783" className='btn btn-primary' target='_blank'>Open Project</a>
          </div>

        </article>

        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG9} alt="" />
          </div><br></br>
          <h4>UI Design for Food Delivery App</h4>
          <h6>UI design for a UI Design for Food Delivery App. 
            Designed using Figma, showcasing my expertise. I design Landind page, Sign In page and Sign Up page The interface offers easy navigation, themed around the enchanting food items. 
            </h6><br></br>
          <div className="portfolio__item-cta">
          
          <a href="https://www.behance.net/gallery/179812121/UI-Design-for-Food-Delivery-App/modules/1015714685" className='btn btn-primary' target='_blank'>Open Project</a>
          </div>

        </article>

        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG10} alt="" />
          </div><br></br>
          <h4>Skincare Store User Interface</h4>
          <h6>UI design for a UI Design for Skincare Store App. 
            Designed using Figma, showcasing my expertise. 
            </h6><br></br>
          <div className="portfolio__item-cta">
          
          <a href="https://www.behance.net/gallery/179812121/UI-Design-for-Food-Delivery-App/modules/1015714685" className='btn btn-primary' target='_blank'>Open Project</a>
          </div>

        </article>

        

        

      

      </div>

    </section>
  )
}

export default Portfolio